import { Dayjs } from 'dayjs';

import { isString, SDate } from '@summit/core';

import { EboObject } from '../base-classes/ebo-object';
import { Company } from '../organization/company/company';
import { Truck } from './truck';
import { TruckAlias } from './truck-alias';

export class AliasAssignment extends EboObject {
  startTime: Dayjs;
  endTime: Dayjs;
  truckID: string;
  truck: Truck;
  aliasID: string;
  alias: TruckAlias;
  settlementCompanyID: string;
  settlementCompany: Company;
  comment: string;

  constructor(jsonData?: Partial<AliasAssignment>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.truck) this.truck = new Truck(jsonData.truck);
      if (jsonData.settlementCompany) this.settlementCompany = new Company(jsonData.settlementCompany);
      if (jsonData.startTime) this.startTime = SDate.newUtc(jsonData.startTime);
      if (jsonData.endTime) this.endTime = SDate.newUtc(jsonData.endTime);
      if (jsonData.alias) this.alias = new TruckAlias(jsonData.alias);
    }
    if (this.endTime === undefined || (isString(this.endTime) && this.endTime === '')) this.endTime = null;
  }

  toShortString(format?: string): string {
    const response = new Array<string>();
    if (format != 'truck') {
      response.push(`${this.truck ? this.truck.toShortString() : 'Unknown'}-`);
    }
    response.push(`${this.alias ? this.alias.toShortString() : 'Unknown'}`);
    if (format == 'truck') {
      response.push(`(${this.settlementCompany ? this.settlementCompany.toShortString() : 'Unknown'})`);
    }
    return response.join(' ');
  }

  getTimeString(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}`;
  }

  toTimeLineView(): string {
    return `${this.getTimeString()}: ${this.truck ? this.truck.toShortString() : 'Unknown'}`;
  }
}
